import { useState } from "react";
import "./DesktopFaqTabs.css";
import { useLang } from "../../../../i18n/LangContext";

export default function DesktopFaqTabs({ id = "faq-tabs" }) {
  const { t } = useLang();
  const tabs = Array.isArray(t?.faqTabs) ? t.faqTabs : [];
  const [activeTab, setActiveTab] = useState(tabs[0]?.id || "");
  const [openIndex, setOpenIndex] = useState(0);

  const currentTab = tabs.find(tab => tab.id === activeTab);

  function toggleQuestion(index) {
    setOpenIndex(prev => (prev === index ? -1 : index));
  }

  return (
    <section id={id} className="faq-tabs-root" aria-label="FAQ tabs">
      <div className="faq-tabs-wrap">
        <div className="faq-tabs-nav" role="tablist">
          {tabs.map(tab => (
            <button
              key={tab.id}
              role="tab"
              className={`faq-tab-btn${tab.id === activeTab ? " is-active" : ""}`}
              onClick={() => {
                setActiveTab(tab.id);
                setOpenIndex(0);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="faq-accordion">
          {currentTab?.faqs?.map((faq, index) => {
            const isOpen = index === openIndex;
            return (
              <article key={index} className={`faq-item${isOpen ? " is-open" : ""}`}>
                <header className="faq-item-header" onClick={() => toggleQuestion(index)}>
                  <span className="faq-item-icon">{isOpen ? "−" : "+"}</span>
                  <h3 className="faq-item-question">{faq.q}</h3>
                </header>
                <div className="faq-item-body" style={{ maxHeight: isOpen ? "400px" : "0px" }}>
                  <p>{faq.a}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
